/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendResource {
    getFixupPrototypeFunction() { return InfraResourceTrendResource.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendResource>): InfraResourceTrendResource {
        let obj = Object.assign(new InfraResourceTrendResource(), model);
        InfraResourceTrendResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendResource>): InfraResourceTrendResource {
        if (!model) return null;
        return InfraResourceTrendResource.newInstance(<InfraResourceTrendResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendResource) {
        if (!obj) return;

        models.InfraResourceTrendResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendResource): boolean {
        Object.setPrototypeOf(obj, InfraResourceTrendResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.added_at === "string") {
            this.added_at = new Date(<string><any>this.added_at);
        }
        if (typeof this.changed_at === "string") {
            this.changed_at = new Date(<string><any>this.changed_at);
        }
        if (typeof this.deleted_at === "string") {
            this.deleted_at = new Date(<string><any>this.deleted_at);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.InfraResourceTrendResourceTag.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the cloud account
     */
    cloud_account_id: string;

    /**
     * Internal inventory identifier for the resource.
     */
    inventory_id: string;

    /**
     * Cloud Provider to select
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Region of the resource
     */
    region: string;

    /**
     * Category of the resource
     */
    resource_category: string;

    /**
     * Type of the resource
     */
    resource_type: string;

    /**
     * Specific resource name or instance identifier
     */
    resource: string;

    /**
     * Unique ID of the resource
     */
    resource_id: string;

    /**
     * Name of the resource
     */
    resource_name: string;

    /**
     * Canonical resource IRI linked from the workload resource via belongsToCanonicalResource.
     */
    belongs_to_canonical_resource: string;

    /**
     * Resource tags as key/value pairs.
     */
    tags: Array<models.InfraResourceTrendResourceTag>;

    /**
     * Timestamp when the resource was added
     */
    added_at: Date;

    /**
     * Timestamp when the resource change was detected
     */
    changed_at: Date;

    /**
     * Timestamp when the resource was deleted
     */
    deleted_at: Date;

}
